import type { IndividualConfig } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';

import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import NotifyActions, { showNotify } from '@common/utils/notify/notify.actions';

@Injectable()
export class NotifyEffects {
    private readonly actions$ = inject(Actions);
    private readonly toastrService = inject(ToastrService);

    private readonly config: Partial<IndividualConfig> = {
        positionClass: 'toast-top-center',
        timeOut: 2500,
        extendedTimeOut: 1000,
        tapToDismiss: false,
        closeButton: true,
        enableHtml: true,
    };

    public readonly showNotify$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(NotifyActions.showNotify, showNotify),
                tap(({ message, title, toastType, config }) =>
                    this.toastrService[toastType](message, title, { ...this.config, ...config })
                )
            ),
        { dispatch: false }
    );
}
